import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchObsSchedulesSuccess,
  fetchObsSchedulesFailure,
  addObsScheduleSuccess,
  addObsScheduleFailure,
  editObsScheduleSuccess,
  editObsScheduleFailure,
  deleteObsScheduleSuccess,
  deleteObsScheduleFailure,
  toggleObsScheduleSuccess,
  toggleObsScheduleFailure,
  fetchDueObservationsSuccess,
  fetchDueObservationsFailure,
  fetchDueSummarySuccess,
  fetchDueSummaryFailure,
} from "./actions";
import {
  FETCH_OBS_SCHEDULES,
  ADD_OBS_SCHEDULE,
  EDIT_OBS_SCHEDULE,
  DELETE_OBS_SCHEDULE,
  TOGGLE_OBS_SCHEDULE,
  FETCH_DUE_OBSERVATIONS,
  FETCH_DUE_SUMMARY,
} from "./constants";
import queryString from "query-string";

function* fetchObsSchedulesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? queryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/observation-schedule?${query}`,
    );
    yield put(fetchObsSchedulesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchObsSchedulesFailure());
    yield put(errorAlert(e?.error || "Error fetching observation schedules"));
  }
}

function* addObsScheduleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/observation-schedule/add`,
      payload,
    );
    yield put(addObsScheduleSuccess(data));
    yield put(successAlert("Observation schedule created successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(addObsScheduleFailure());
    yield put(errorAlert(e?.error || "Error creating observation schedule"));
  }
}

function* editObsScheduleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/observation-schedule/edit/${payload.id}`,
      payload.data,
    );
    yield put(editObsScheduleSuccess(data));
    yield put(successAlert("Observation schedule updated successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(editObsScheduleFailure());
    yield put(errorAlert(e?.error || "Error updating observation schedule"));
  }
}

function* deleteObsScheduleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/observation-schedule/${payload}`,
    );
    yield put(deleteObsScheduleSuccess(data));
    yield put(successAlert("Observation schedule deleted successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(deleteObsScheduleFailure());
    yield put(errorAlert(e?.error || "Error deleting observation schedule"));
  }
}

function* toggleObsScheduleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/observation-schedule/${payload.id}/toggle-active`,
      { is_active: payload.is_active },
    );
    yield put(toggleObsScheduleSuccess(data));
    yield put(
      successAlert(
        `Schedule ${payload.is_active ? "activated" : "paused"} successfully!`,
      ),
    );
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(toggleObsScheduleFailure());
    yield put(errorAlert(e?.error || "Error toggling schedule"));
  }
}

function* fetchDueObservationsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload.params ? queryString.stringify(payload.params) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${payload.residentId}/due-observations?${query}`,
    );
    yield put(fetchDueObservationsSuccess(data?.data || data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchDueObservationsFailure());
    yield put(errorAlert(e?.error || "Error fetching due observations"));
  }
}

function* fetchDueSummarySaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  // payload can be a plain resident_id string (legacy) or { resident_id, assessment_template_id }
  const residentId =
    typeof payload === "object" ? payload.resident_id : payload;
  const params =
    typeof payload === "object" && payload.assessment_template_id
      ? queryString.stringify({
          assessment_template_id: payload.assessment_template_id,
        })
      : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/due-observations/summary${params ? `?${params}` : ""}`,
    );
    yield put(fetchDueSummarySuccess(data?.data || data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchDueSummaryFailure());
    yield put(errorAlert(e?.error || "Error fetching due observation summary"));
  }
}

export default function* ObservationScheduleSaga() {
  yield all([
    takeEvery(FETCH_OBS_SCHEDULES, fetchObsSchedulesSaga),
    takeEvery(ADD_OBS_SCHEDULE, addObsScheduleSaga),
    takeEvery(EDIT_OBS_SCHEDULE, editObsScheduleSaga),
    takeEvery(DELETE_OBS_SCHEDULE, deleteObsScheduleSaga),
    takeEvery(TOGGLE_OBS_SCHEDULE, toggleObsScheduleSaga),
    takeEvery(FETCH_DUE_OBSERVATIONS, fetchDueObservationsSaga),
    takeEvery(FETCH_DUE_SUMMARY, fetchDueSummarySaga),
  ]);
}
